export var BUSINESS_TAG;
(function (BUSINESS_TAG) {
    BUSINESS_TAG["DDDF"] = "3df";
    BUSINESS_TAG["WANG"] = "wang";
    BUSINESS_TAG["SRC"] = "src";
})(BUSINESS_TAG || (BUSINESS_TAG = {}));
